"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Iframe.scss");
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _figmaLogo = _interopRequireDefault(require("./assets/figmaLogo.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// You can create a corresponding SCSS file for styling

var IframeComponent = function IframeComponent(_ref) {
  var url = _ref.url,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Iframe Title" : _ref$title;
  if (!url) {
    return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
      direction: "column",
      customClass: "FigmaIntegrationMessage"
    }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
      size: "large",
      weight: "bold"
    }, "Figma integration"), /*#__PURE__*/_react["default"].createElement("img", {
      src: _figmaLogo["default"],
      className: "UpdatesLogo",
      alt: "Figma Logo"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("iframe", {
    src: url,
    title: title,
    className: "iframeComponent" // You can define styles in IframeComponent.scss
    ,
    frameBorder: "0",
    allowFullScreen: true
  });
};
var _default = exports["default"] = IframeComponent;